import { render, staticRenderFns } from "./TemplateYearForm.vue?vue&type=template&id=1bd64927&"
import script from "./TemplateYearForm.vue?vue&type=script&lang=ts&"
export * from "./TemplateYearForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports